import { request } from '@/utils/request';

/**
 * 加载档口首页数据（商品统计、销售统计、积分排名、上货平台等）
 */
export function loadSellerIndexData(siteCode: string = '') {
  return request<API.SellerIndexDataResult>({
    url: '/v1/seller/indexData',
    method: 'GET',
    headers: {
      site: siteCode,
    },
  });
}

/**
 * 获取档口店铺信息
 */
export function loadSellerInfo() {
  return request<API.SellerInfoResult>({
    url: '/v1/seller/getSellerInfo',
    method: 'GET',
  });
}

/**
 * 修改档口头像
 */
export function setSellerPic(data: API.SetSellerPicParams) {
  return request({
    url: '/v1/seller/setPic',
    method: 'POST',
    data,
  });
}

/**
 * 保存店铺信息
 */
export function setShopInfo(data: API.SetShopInfoParams) {
  return request({
    url: '/v1/seller/setInfo',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 获取档口主营标签列表
 */
export function getBoothsTags() {
  return request<API.BoothsTag[]>({
    url: '/v1/getSellerTagList',
    method: 'GET',
  });
}

/**
 * 获取档口粉丝列表
 */
export function getBoothsFans(page: number = 1, pageSize: number = 10) {
  return request({
    url: '/v1/seller/colUserList',
    method: 'GET',
    data: { page, pageSize },
  });
}

/**
 * 获取暗款邀请码
 */
export function getColCode(data: API.GetColCodeParam) {
  return request<API.GetColCodeResult>({
    url: '/v1/seller/getColCode',
    method: 'POST',
    data,
  });
}

/**
 * 获取保证金信息
 */
export function getSellerDeposit() {
  return request<API.SellerDepositResult>({
    url: '/seller/erpSellerAmount/getInfo',
    method: 'POST',
  });
}

/**
 * 提交企业资质信息
 */
export function setCompanyInfo(data: API.SetCompanyInfoParams) {
  return request({
    url: '/v1/seller/setZz',
    method: 'POST',
    data,
  });
}
